var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHlPractice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98_1874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.375 14.375C19.375 17.125 17.125 19.375 14.375 19.375C11.625 19.375 9.375 17.125 9.375 14.375C9.375 11.625 11.625 9.375 14.375 9.375",
    stroke: "#737373",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3749 10.625L14.7916 15.2083C14.5416 15.4583 14.1249 15.4583 13.8749 15.2083L12.4583 13.7917",
    stroke: "#737373",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36225 17.8742L0.625 19.375L2.12168 13.6219M6.36225 17.8742L2.12168 13.6219M6.36225 17.8742L7.11059 17.1237M2.12168 13.6219L14.1783 1.53201C15.3423 0.364712 17.2548 0.281333 18.5019 1.53201C19.666 2.69931 19.666 4.61698 18.5019 5.86766L17.0884 7.2851M13.8456 1.8655L18.1753 6.19519M14.5939 6.95168L11.6838 4.03343",
    stroke: "#737373",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_98_1874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHlPractice);
export default __webpack_public_path__ + "static/media/HL_Practice.823bed3b04ff85631e51dfa5409e7226.svg";
export { ForwardRef as ReactComponent };